import { Popover as PopoverPrimitive } from "@base-ui/react/popover"
import { POPUP_STYLES } from "../constants"
import { cn } from "../utils"

export const Popover = PopoverPrimitive.Root
export const PopoverTrigger = PopoverPrimitive.Trigger
const PopoverPortal = PopoverPrimitive.Portal
const PopoverPositioner = PopoverPrimitive.Positioner

export function PopoverPopup({
   className,
   children,
   sideOffset = 4,
   light = true,
   ...props
}: React.ComponentProps<typeof PopoverPrimitive.Positioner> & {
   light?: boolean
}) {
   return (
      <PopoverPortal>
         <PopoverPositioner
            sideOffset={sideOffset}
            className={"z-51"}
            {...props}
         >
            <PopoverPrimitive.Popup
               className={cn(
                  POPUP_STYLES.base,
                  POPUP_STYLES.transition,
                  light
                     ? "not-dark:border border-surface-12/12 bg-background px-3 py-2.5 text-foreground shadow-xl"
                     : "",
                  className,
               )}
            >
               {children}
            </PopoverPrimitive.Popup>
         </PopoverPositioner>
      </PopoverPortal>
   )
}
